import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import PreferenceCheckbox from "discourse/components/preference-checkbox";
import { i18n } from "discourse-i18n";

export default class CirclesUserNotificationPreferences extends Component {
  @tracked show = false;

  constructor() {
    super(...arguments);

    this.show = Object.keys(this.args.outletArgs.model.user_option).includes(
      "notify_on_circle_mention"
    );
  }

  <template>
    {{#if this.show}}
      <div class="control-group circles-notifications">
        <label class="control-label">
          {{i18n "discourse_circles.user.circles"}}
        </label>

        <div class="controls notify-on-circle-mention">
          <PreferenceCheckbox
            @labelKey="discourse_circles.user.notification_preferences.notify_on_circle_mention"
            @checked={{@outletArgs.model.user_option.notify_on_circle_mention}}
          />
        </div>
      </div>
    {{/if}}
  </template>
}
